"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapToTypeaheadOptions = mapToTypeaheadOptions;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Spinner = _interopRequireDefault(require("./Spinner"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _TypeaheadModule = _interopRequireDefault(require("./Typeahead.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function mapToTypeaheadOptions(list, displayTextField) {
  var valueField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : displayTextField;
  return list.map(function (element) {
    return _objectSpread({
      displayText: element[displayTextField],
      value: element[valueField]
    }, element);
  });
}

// documentation: https://vitusvet.atlassian.net/l/c/cwDVN8pW
var Typeahead = function Typeahead(props) {
  var value = props.value,
      _props$selectedItem = props.selectedItem,
      selectedItem = _props$selectedItem === void 0 ? null : _props$selectedItem,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$inputClassName = props.inputClassName,
      inputClassName = _props$inputClassName === void 0 ? '' : _props$inputClassName,
      _props$menuClassName = props.menuClassName,
      menuClassName = _props$menuClassName === void 0 ? '' : _props$menuClassName,
      _props$menuItemClassN = props.menuItemClassName,
      menuItemClassName = _props$menuItemClassN === void 0 ? '' : _props$menuItemClassN,
      _props$async = props.async,
      async = _props$async === void 0 ? false : _props$async,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$scrollToBottom = props.scrollToBottom,
      scrollToBottom = _props$scrollToBottom === void 0 ? false : _props$scrollToBottom,
      _props$displayClearBu = props.displayClearButton,
      displayClearButton = _props$displayClearBu === void 0 ? false : _props$displayClearBu,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
      _props$onItemSelected = props.onItemSelected,
      onItemSelected = _props$onItemSelected === void 0 ? function () {} : _props$onItemSelected;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var isItemSelected = selectedItem !== null;

  var handleChange = function handleChange(e) {
    onItemSelected(null);
    setMenuOpen(true);
    onChange(e);
  };

  var handleItemSelected = function handleItemSelected(selectedOption) {
    onItemSelected(selectedOption);
  };

  var handleBlur = function handleBlur() {
    setMenuOpen(false);
  };

  var handleFocus = function handleFocus() {
    setMenuOpen(true);
  };

  var getOptions = function getOptions() {
    if (async) return options; // locally search for matches when async disabled

    return options.filter(function (opt) {
      // this regex matches multiple words (in order)
      var re = new RegExp(value.split(' ').map(function (s) {
        return "(.*".concat(s, ".*)");
      }).join(''), 'i');
      return re.test(opt.displayText);
    });
  };

  var shouldShowMenu = !isLoading && !isItemSelected && isMenuOpen && options.length > 0; // logic for scrolling the bottom of the dropdown into view

  var scrollAnchorRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _scrollAnchorRef$curr;

    if (!(shouldShowMenu && scrollToBottom)) return;
    (_scrollAnchorRef$curr = scrollAnchorRef.current) === null || _scrollAnchorRef$curr === void 0 ? void 0 : _scrollAnchorRef$curr.scrollIntoView({
      behavior: 'smooth',
      block: 'end'
    });
  }, [shouldShowMenu, scrollToBottom]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: [className, _TypeaheadModule.default.typeaheadFormGroup].join(' '),
    onFocus: handleFocus,
    onBlur: handleBlur
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    autoComplete: "off",
    onChange: handleChange,
    className: [_TypeaheadModule.default.typeaheadInput, inputClassName].join(' '),
    disabled: displayClearButton && isItemSelected,
    value: value,
    placeholder: placeholder
  }), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: _TypeaheadModule.default.spinnerBox
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
    size: "auto"
  })) : displayClearButton && isItemSelected && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTimes,
    className: _TypeaheadModule.default.clearButton,
    onClick: function onClick() {
      onItemSelected(null);
      onChange({
        target: {
          value: ''
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: [menuClassName, _TypeaheadModule.default.typeaheadListGroup, _TypeaheadModule.default.listGroup].join(' '),
    ref: scrollAnchorRef
  }, shouldShowMenu && getOptions().map(function (item, id) {
    return /*#__PURE__*/_react.default.createElement("button", {
      key: id,
      className: [menuItemClassName, _TypeaheadModule.default.typeaheadListGroupItem, _TypeaheadModule.default.listGroupItem].join(' '),
      onMouseDown: function onMouseDown() {
        return handleItemSelected(item);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _TypeaheadModule.default.itemText
    }, item.displayText));
  })));
};

var _default = Typeahead;
exports.default = _default;